import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

function authHeaders() {
  return {
    Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
  };
}

function asArray(data) {
  const list = Array.isArray(data) ? data : data?.data;
  return Array.isArray(list) ? list : [];
}

/** API often returns an empty/zero-default `filmData` object instead of omitting it. */
export function isPlaceholderFasaraFilmData(fd) {
  if (!fd || typeof fd !== 'object') {
    return true;
  }
  if (fd.name != null && String(fd.name).trim() !== '') {
    return false;
  }
  const thumb =
    fd.externalThumbnailUrl ||
    fd.external_thumbnail_url ||
    fd.externalImageURL ||
    fd.externalImageUrl;
  if (thumb != null && String(thumb).trim() !== '') {
    return false;
  }
  const gd = fd.groupData;
  if (gd && typeof gd === 'object') {
    if (String(gd.name || '').trim() !== '') return false;
    if (String(gd.category || '').trim() !== '') return false;
  }
  return true;
}

function narrowFilmsByFamily(items, family) {
  if (!Array.isArray(items)) {
    return [];
  }
  const narrowed = items.filter((item) => {
    if (item.family == null && item.familyId == null && item.line == null) {
      return true;
    }
    return (
      String(item.family) === String(family) ||
      String(item.familyId) === String(family)
    );
  });
  return narrowed.length > 0 ? narrowed : items;
}

export async function fetchFasaraFilmsForFamily(family) {
  if (family == null || family === '') {
    return [];
  }
  try {
    const response = await axios.get(`${API_URL}/films/arqfinishes`, {
      params: { family },
      headers: authHeaders(),
    });
    const list = asArray(response.data);
    return narrowFilmsByFamily(list, family);
  } catch (e) {
    console.error('fetchFasaraFilmsForFamily', e);
    return [];
  }
}

export async function fetchFasaraFamiliesForCategory(categoryValue) {
  if (categoryValue == null || categoryValue === '') {
    return [];
  }
  try {
    const response = await axios.get(`${API_URL}/families/arqfinishes`, {
      params: { type: 'FASARA', category: categoryValue },
      headers: authHeaders(),
    });
    return asArray(response.data);
  } catch (e) {
    console.error('fetchFasaraFamiliesForCategory', e);
    return [];
  }
}

export function pickProductLabelFromFilmsList(list, filmId) {
  if (!Array.isArray(list) || filmId == null || filmId === '') {
    return null;
  }
  const needle = String(filmId).trim();
  const row = list.find((item) => {
    const keys = [
      item.code,
      item.filmCode,
      item.sku,
      item.productCode,
      item.value,
      item.id,
      item.filmId,
    ].filter((k) => k != null && k !== '');
    return keys.some((k) => String(k).trim() === needle);
  });
  if (!row) {
    return null;
  }
  const label = row.label ?? row.name;
  return label != null && String(label).trim() !== ''
    ? String(label).trim()
    : null;
}

export function pickFamilyLabelFromFamiliesList(list, familyId) {
  if (!Array.isArray(list) || familyId == null || familyId === '') {
    return null;
  }
  const needle = String(familyId).trim();
  const row = list.find((item) => {
    const keys = [item.id, item.value, item.code].filter(
      (k) => k != null && k !== '',
    );
    return keys.some((k) => String(k).trim() === needle);
  });
  if (!row) {
    return null;
  }
  const label = row.name ?? row.label;
  return label != null && String(label).trim() !== ''
    ? String(label).trim()
    : null;
}
